(function() {
    const btn = document.getElementById('mobileNavBtn');
    const panel = document.getElementById('mobileNavPanel');
    if (!btn || !panel) return;
    btn.addEventListener('click', ()=>{
        panel.classList.toggle('hidden');
        panel.classList.toggle('block');
    });
})();

//# sourceMappingURL=repo.a8046221.js.map
